import React, { useState, useEffect, Fragment } from 'react';
import { 
  Card, CardContent, Typography, Box, Button, Dialog, DialogContent,
  FormControl, OutlinedInput, InputLabel, Select, MenuItem, TextField, Alert,
  Slide, Chip, Avatar, CircularProgress, alpha, useTheme
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useMutation } from "react-query";
import { useNavigate, useParams } from 'react-router-dom';
import { Currency } from '@depay/local-currency';
import { QRCode } from 'react-qrcode-logo';
import { CopyToClipboard } from 'react-copy-to-clipboard';

// Icons
import { AccountBalance as PortfolioIcon } from '@mui/icons-material';

import apiClient from "../../request/http-common";
import { setInvestments } from '../../request/Analysis/hitorySlice';
import { setPlans, setCategories } from '../../request/Plans/planSlice';

// Transition Component
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CategoryPlans = () => {
  const theme = useTheme();
  
  // Add error state
  const [componentError, setComponentError] = useState(null);
  
  const getCategoryConfig = (categoryName) => {
    // Decode URL parameter
    const decodedCategoryName = decodeURIComponent(categoryName || '');
    
    // Find category from Redux state
    const categoryData = categories.find(cat => 
      cat.name?.toLowerCase() === decodedCategoryName?.toLowerCase()
    );
    
    if (categoryData) {
      return {
        title: categoryData.display_name || categoryData.name,
        subtitle: categoryData.description || '',
        color: categoryData.color || '#F7931A'
      };
    }
    
    // Fallback for dynamic categories
    return {
      title: decodedCategoryName,
      subtitle: 'Professional investment opportunities designed to grow your wealth.',
      color: '#F7931A'
    };
  };

  const getPlanTier = (plan) => {
    if (!plan) {
      return { 
        label: plan?.tier_label || 'Basic', 
        color: plan?.tier_color || '#6366F1', 
        tier: plan?.tier || 'basic',
        features: plan?.features ? plan.features.split(',') : []
      };
    }
    
    return {
      label: plan.tier_label || 'Basic',
      color: plan.tier_color || '#6366F1',
      tier: plan.tier || 'basic',
      features: plan.features ? plan.features.split(',') : []
    };
  };

  const getPerformanceMetrics = (plan) => {
    if (!plan) {
      return {
        roi: 0,
        riskLevel: 'Low',
        timeframe: 'N/A',
        successRate: 0,
        avgReturn: '0.0%',
        hourlyRate: 0,
        initialEarning: 0,
        downlines: 0,
        bonusPerDownline: 0
      };
    }
    
    const roi = parseFloat(plan.total_earning) || 0;
    const hourlyRate = parseFloat(plan.amount_per_hour) || 0;
    const initialEarning = parseFloat(plan.initial_earning) || 0;
    const downlines = parseInt(plan.number_of_downlines) || 0;
    const bonusPerDownline = parseFloat(plan.bonus_per_downline) || 0;
    
    return {
      roi: roi,
      riskLevel: plan.risk_level || 'Low',
      timeframe: plan.duration || 'N/A',
      successRate: parseFloat(plan.success_rate) || 0,
      avgReturn: plan.avg_return || `${roi.toFixed(1)}%`,
      hourlyRate: hourlyRate,
      initialEarning: initialEarning,
      downlines: downlines,
      bonusPerDownline: bonusPerDownline
    };
  };

  const coinRates = useSelector((state) => state.coins.coinRates);
  const fundings = useSelector((state) => state.wallet.fundings);
  const tradings = useSelector((state) => state.history.tradings);
  const addresses = useSelector((state) => state.coins.addresses);

  const params = useParams();
  
  const calculateBalance = (coin) => {
    let amount = 0;
    fundings.forEach(fund => {
      if (fund.gateway === coin) {
        amount += parseFloat(fund.amount);
      }
      });

      tradings.forEach(trade => {
        if (trade.pair === coin) {
          amount += parseFloat(trade.profit);
        }
        });
    
      return amount;
  }

  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = useState(0);

  const handleClickOpen = () => {
    setOpen(true);
    setErros(null); // Clear any previous errors
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPlan(null);
    setPlanId(null);
    setAmount(0);
    setCurrentDuration('');
    setSource('');
    setErros(null);
  };
  
  const navigate = useNavigate();
  const plans = useSelector((state) => state.plans.plans);
  const categories = useSelector((state) => state.plans.categories);
  const user = useSelector((state) => state.user.user);

    const fundingBal = useSelector((state) => state.wallet.fundingBalance);
    const subBal = useSelector((state) => state.wallet.subscriptionBalance);
    const refBal = useSelector((state) => state.wallet.referralBalance);
    const mainBal = useSelector((state) => state.wallet.withdrawableBalance);
  
  const formatPrice = (amount) => {
    try {
      return new Intl.NumberFormat('en-US', { 
        style: 'currency', 
        currency: 'USD', 
        currencySign: 'standard' 
      }).format(amount || 0);
    } catch (error) {
      // Fallback formatting if Intl.NumberFormat fails
      return `$${(amount || 0).toFixed(2)}`;
    }
  };

  const dispatch = useDispatch();
  const [rate, setRate] = useState(1);

  const callRate = async()=> {
    try {
      if(user?.currency === 'USD'){
        setRate(1);
      }else{
        await Currency.fromUSD({ amount: 1 }).then(amount=>{
          setRate(amount.amount);
         }).catch(error => {
           console.error('Currency conversion error:', error);
           setRate(1); // Fallback to USD rate
         });
      }
    } catch (error) {
      console.error('callRate error:', error);
      setRate(1); // Fallback to USD rate
    }
  };

    const setcategories = (number_of_downlines, total_earning, initial_earning) => {
        const categories = [];
        const numDownlines = parseInt(number_of_downlines) || 0;
        const totalEarning = parseFloat(total_earning) || 0;
        const initialEarningAmount = parseFloat(initial_earning) || 0;
        
        for (let i = 0; i <= numDownlines; i++) {
            let heads = '';
            for (let j = 1; j <= i; j++) {
                heads += '🙂';
            }

            if (i === 0) {
              const initialPercentage = totalEarning > 0 ? (initialEarningAmount / totalEarning) * 100 : 0;
                categories.push('INITIAL ROI = ' + initialPercentage.toFixed(2) + '%');
            } else if (i === numDownlines) {
                categories.push('STAGE ' + i + ' = ' + heads + '');
            } else {
                categories.push('STAGE ' + i + ' = ' + heads);
            }
        }
        return categories;
    }

    const setAmounts = (initial_earning, total_earning, number_of_downlines, bonus_per_downline, amount_invested) => {
      const initialEarningAmount = parseFloat(initial_earning) || 0;
      const totalEarning = parseFloat(total_earning) || 0;
      const numDownlines = parseInt(number_of_downlines) || 0;
      const bonusPerDownline = parseFloat(bonus_per_downline) || 0;
      
      const initialPercentage = totalEarning > 0 ? (initialEarningAmount / totalEarning) * 100 : 0;
      const amounts = [initialPercentage.toFixed(2)];
      
      for (let downlines = 1; downlines <= numDownlines; downlines++) {
        amounts.push(parseFloat(bonusPerDownline * downlines).toFixed(2));
      }

      return amounts;
    }

    const [planId, setPlanId] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [source, setSource] = useState('');
    const [currentDuration, setCurrentDuration] = useState('');
    const [convertedAmount, setConvertedAmount] = useState(0);
    const [error, setErros] = useState(null);

     // for new balance method
     const [buttonText, setbuttonText] = useState(null);
     const [selectedCoin, setSelectedCoin] = useState(null);
 
       const getCoinDetails = (coinName) => {
    if (!coinName) {
      setSelectedCoin(null);
      return;
    }
    
    switch (coinName) {
      case 'Overall Asset':
        setSelectedCoin(null) 
        break;
      case 'Referral Wallet':
        setSelectedCoin(null) 
        break;
      default:
        const foundAddress = addresses.find(address => address.coin_name === coinName);
        setSelectedCoin(foundAddress || null);
        break;
    }
  }

    const { isLoading: isInvesting, mutate: postInvestment } = useMutation(
        async () => {
          return await apiClient.post(`/api/invest`, {
            investment_plan_id: planId,
            amount: amount, 
            rate: rate,
            duration: currentDuration,
            payment_source: source
          });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
                dispatch(setInvestments(res.data.investments));
                setTimeout(() => {
                  navigate('/investments');
                }, 2000);
              }            
          },
          onError: (err) => {
            try {
              if (err.response?.data?.errors) {
                setErros(err.response.data.errors);
              } else if (err.response?.data?.message) {
                let errorMessage = err.response.data.message;
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              } else {
                let errorMessage = err.message || 'An error occurred during investment';
                localStorage.setItem('notification', JSON.stringify({message : `${errorMessage}`, 'type': 'error' }));
                const event = new Event('newMessage');
                window.dispatchEvent(event);
              }
            } catch (error) {
              // Fallback error handling
              localStorage.setItem('notification', JSON.stringify({message : 'An error occurred during investment', 'type': 'error' }));
              const event = new Event('newMessage');
              window.dispatchEvent(event);
            }
          },
        }
      );

      
      useEffect(() => {
        callRate();
        
        // If plans or categories are not loaded, try to load them
        if (!plans || plans.length === 0 || !categories || categories.length === 0) {
          const loadData = async () => {
            try {
              const response = await apiClient.get("/api/investment-plans");
              if (response.data.status === 'success') {
                dispatch(setPlans(response.data.plans));
                dispatch(setCategories(response.data.categories));
              }
            } catch (error) {
              console.error('Error loading investment plans:', error);
            }
          };
          loadData();
        }
        
        // Cleanup function to prevent memory leaks
        return () => {
          setComponentError(null);
          setErros(null);
        };
      }, [plans, categories, dispatch]);

  const categoryConfig = getCategoryConfig(params.id);
  
  // Use localStorage data if Redux data is not available
  const plansToUse = plans.length > 0 ? plans : JSON.parse(localStorage.getItem('plans') || '[]');
  const categoriesToUse = categories.length > 0 ? categories : JSON.parse(localStorage.getItem('categories') || '[]');
  
  // Find the category by name first
  const targetCategory = categoriesToUse.find(cat => 
    cat.name?.toLowerCase().trim() === decodeURIComponent(params.id || '')?.toLowerCase().trim()
  );
  
  // Dynamic filtering based on category name from URL
  const categoryPlans = plansToUse.filter(plan => {
    // Check if plan has category data
    if (!plan.category) {
      return false;
    }
    
    // Try different ways to access category name and trim whitespace
    let planCategoryName = '';
    
    if (typeof plan.category === 'string') {
      planCategoryName = plan.category.toLowerCase().trim();
    } else if (plan.category && typeof plan.category === 'object') {
      planCategoryName = plan.category.name?.toLowerCase().trim() || '';
    } else if (plan.category_id) {
      planCategoryName = plan.category_id.toString();
    }
    
    const urlCategoryName = decodeURIComponent(params.id || '')?.toLowerCase().trim();
    
    // Also check by category ID if we found the target category
    const matchesByName = planCategoryName === urlCategoryName;
    const matchesById = targetCategory && plan.category_id === targetCategory.id;
    
    // Match by name or ID
    return matchesByName || matchesById;
  });

  // Error boundary - if there's a component error, show error message
  if (componentError) {
    return (
      <Box sx={{ 
        padding: 3, 
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        <Alert severity="error" sx={{ marginBottom: 2 }}>
          An error occurred while loading the investment portfolios. Please refresh the page.
        </Alert>
        <Button 
          onClick={() => window.location.reload()} 
          variant="contained"
          sx={{ background: '#F7931A' }}
        >
          Refresh Page
        </Button>
      </Box>
    );
  }

  try {
    return (
      <Box sx={{ 
        paddingX: 2,
        paddingTop: { xs: 2, sm: 1, md: 0 },
        paddingBottom: 3,
        maxWidth: '800px',
        margin: '0 auto'
      }}>
      
      {/* Minimal Header */}
      <Box sx={{ textAlign: 'center', marginBottom: 3 }}>
        <Typography 
          variant="h5"
          sx={{ 
            fontWeight: 700,
            fontSize: { xs: '1.5rem', sm: '1.75rem' },
            color: theme.palette.text.primary,
            marginBottom: 1
          }}
        >
        {categoryConfig.title}
    </Typography>
        <Typography 
          variant="body2"
          sx={{ 
            color: theme.palette.text.secondary,
            fontSize: '0.875rem'
          }}
        >
       {categoryConfig.subtitle}
      </Typography>
      </Box>

        {/* Minimal Plans List - Bybit Style */}
        {!plans || plans.length === 0 ? (
          <Box sx={{ textAlign: 'center', padding: 4 }}>
            <CircularProgress sx={{ color: '#F7931A' }} />
            <Typography variant="body2" sx={{ marginTop: 2, color: 'text.secondary' }}>
              Loading investment plans...
            </Typography>
          </Box>
        ) : !categoryPlans || categoryPlans.length === 0 ? (
          <Box sx={{ textAlign: 'center', padding: 4 }}>
            <Alert severity="info">
              No investment plans found for category: "{params.id}"
            </Alert>
            <Typography variant="body2" sx={{ marginTop: 2, color: 'text.secondary' }}>
              Available categories: {categoriesToUse.map(cat => cat.name).join(', ')}
            </Typography>
            <Typography variant="body2" sx={{ marginTop: 1, color: 'text.secondary' }}>
              Total plans available: {plansToUse.length}
            </Typography>
            {plansToUse.length > 0 && (
              <Typography variant="body2" sx={{ marginTop: 1, color: 'text.secondary' }}>
                Sample plan categories: {plansToUse.slice(0, 3).map(plan => plan.category?.name || plan.category_id || 'No category').join(', ')}
              </Typography>
            )}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {categoryPlans.map((plan, index) => {
              if (!plan) return null; // Skip if plan is null/undefined
              
              const tierInfo = getPlanTier(plan);
              const metrics = getPerformanceMetrics(plan);
              
              return (
                <Card 
                  key={`${plan.id}-${plan.name}`}
                  sx={{ 
                    background: theme.palette.background.paper,
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: '12px',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: theme.palette.mode === 'dark' 
                        ? '0 8px 24px rgba(0, 0, 0, 0.4)' 
                        : '0 8px 24px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ padding: '16px !important' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      
                      {/* Small Icon */}
                      <Avatar 
                        sx={{ 
                          width: 32, 
                          height: 32,
                          background: `linear-gradient(135deg, ${tierInfo.color}, ${alpha(tierInfo.color, 0.8)})`,
                        }}
                      >
                        <PortfolioIcon sx={{ fontSize: 16, color: 'white' }} />
                      </Avatar>
                      
                      {/* Content */}
                      <Box sx={{ flexGrow: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 0.5 }}>
                          <Typography 
                            variant="subtitle1" 
                            sx={{ 
                              fontWeight: 700,
                              fontSize: '1rem',
                              color: theme.palette.text.primary
                            }}
                          >
                {plan.name}
                </Typography>

                          {plan.promo_label && (
                            <Chip 
                              label={plan.promo_label}
                              size="small"
                              sx={{ 
                                background: plan.promo_color || '#FF6B35',
                                color: 'white',
                                fontSize: '0.7rem',
                                height: 18,
                                fontWeight: 600
                              }}
                            />
                          )}
                        </Box>
                        
                        {/* ROI Display with hourly rate */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 0.5 }}>
                          <Typography 
                            variant="h6" 
                            sx={{ 
                              fontWeight: 800,
                              fontSize: '1.1rem',
                              color: '#10B981'
                            }}
                          >
                            {metrics.roi.toFixed(2)}%
                          </Typography>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              color: theme.palette.text.secondary,
                              fontSize: '0.75rem'
                            }}
                          >
                            Yield Rate Monthly
                          </Typography>
                        </Box>
                        
                        {/* Duration Display */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 0.5 }}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontWeight: 600,
                              fontSize: '0.85rem',
                              color: '#F7931A'
                            }}
                          >
                            {plan.duration || 'N/A'}
                          </Typography>
                          <Typography 
                            variant="caption" 
                            sx={{ 
                              color: theme.palette.text.secondary,
                              fontSize: '0.75rem'
                            }}
                          >
                            Duration Options
                          </Typography>
                        </Box>



                        {/* Description removed as requested */}
                        {plan.description && (
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: theme.palette.text.secondary,
                              fontSize: '0.8rem',
                              lineHeight: 1.3,
                              marginBottom: 1
                            }}
                          >
                            {plan.description}
                          </Typography>
                        )}
                </Box>

                      {/* Action Button */}
                      <Button
                        onClick={() => {
                          handleClickOpen();
                          setPlanId(plan.id);
                          setSelectedPlan(plan);
                          setConvertedAmount(parseFloat(plan.amount_invested || 0));
                        }}
                        disabled={isInvesting && planId === plan.id}
                        sx={{
                          background: '#F7931A',
                          color: 'white',
                          fontSize: '0.8rem',
                          fontWeight: 700,
                          padding: '6px 16px',
                          borderRadius: '8px',
                          textTransform: 'none',
                          minWidth: 'auto',
                          '&:hover': {
                            background: '#E8851A'
                          },
                          '&:disabled': {
                            background: theme.palette.action.disabledBackground,
                            color: theme.palette.action.disabled
                          }
                        }}
                      >
                        {isInvesting && planId === plan.id ? (
                          <CircularProgress size={16} sx={{ color: 'white' }} />
                        ) : (
                          'Invest'
                        )}
                  </Button>
                  </Box>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
        )}

        {/* Minimal Investment Modal */}
      <Dialog
          fullWidth
          maxWidth="sm"
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: '16px',
              margin: 2
            }
          }}
        >
          {selectedPlan !== null && 
          <DialogContent sx={{ padding: 3 }}>
            
            {/* Simple Header */}
            <Box sx={{ textAlign: 'center', marginBottom: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, marginBottom: 1, color: theme.palette.text.primary }}>
                {selectedPlan?.name || 'Investment'}
              </Typography>
              {selectedPlan && (
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                  {formatPrice(selectedPlan.min_amount || 0)} - {parseInt(selectedPlan.amount_invested || 0) >= 1000000 ? 'UNLIMITED' : formatPrice(selectedPlan.amount_invested || 0)}
                </Typography>
              )}
            </Box>

            {/* Compact Form */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              
              {/* Amount Input */}
              <FormControl fullWidth>
                <InputLabel>Investment Amount</InputLabel>
              <OutlinedInput
                  value={amount || ''}
                  onChange={(e) => setAmount(e.target.value)}
                  type="number"
                  label="Investment Amount"
                  startAdornment={<Typography sx={{ marginRight: 1, color: theme.palette.text.secondary }}>$</Typography>}
              />
            </FormControl>

              {/* Duration Selection */}
              {selectedPlan && selectedPlan.duration && selectedPlan.duration.split(',').length > 0 && (
                <FormControl fullWidth>
                  <InputLabel>Duration</InputLabel>
                        <Select
                    value={currentDuration || ''}
                        onChange={(e) => setCurrentDuration(e.target.value)}
                    label="Duration"
                    error={error && error.duration}
                  >
                    {selectedPlan.duration && selectedPlan.duration.split(',').map((duration, index) => (
                      <MenuItem key={`duration-${duration}-${index}`} value={duration}>
                        {duration}
                            </MenuItem>              
                            ))}  
                        </Select>
                  {error && error.duration && (
                    <Typography color="error" variant="caption">
                      {error.duration}
                        </Typography>
                  )}
                    </FormControl>
              )}

              {/* Payment Source */}
              <FormControl fullWidth>
                <InputLabel>Payment Source</InputLabel>
                          <Select
                  value={source || ''}
                  onChange={(e) => {
                    setSource(e.target.value);
                    getCoinDetails(e.target.value);
                  }}
                  label="Payment Source"
                  error={error && error.source}
                >
                  <MenuItem value="Overall Asset">
                    Overall Asset (Balance: {formatPrice(fundingBal)})
                              </MenuItem> 
                          </Select>
                {error && error.source && (
                  <Typography color="error" variant="caption">
                    {error.source}
                          </Typography>
                )}
                      </FormControl>

              {/* Payment Details */}
              {selectedCoin && (
                <Box>
                  <Alert severity="info" sx={{ marginBottom: 2 }}>
                                      {selectedCoin.wallet_type === 'bank' 
                    ? `Make payment to our ${selectedCoin.coin_name || 'bank'} account`
                    : `Send ${formatPrice(amount || 0)} worth of ${selectedCoin.coin_name || 'crypto'} to address below`
                  }
                        </Alert>                       
                      
                  {selectedCoin.wallet_type === 'Crypto' && selectedCoin.address && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
                      <QRCode 
                        qrStyle="dots" 
                        value={selectedCoin.address} 
                        size={150}
                        logoImage=""
                      />
                      </Box>
                  )}

                  <CopyToClipboard 
                    onCopy={() => {
                      setbuttonText(selectedCoin.wallet_type === 'bank' ? 'Copied!' : 'Address Copied!');
                      setTimeout(() => setbuttonText(null), 2000);
                    }} 
                    text={selectedCoin.address || ''}
                  >
                                  <TextField
                      fullWidth
                      multiline
                      rows={2}
                      value={selectedCoin.address || ''}
                      label={buttonText || 'Click to copy address'}
                      sx={{ cursor: 'pointer' }}
                    />
                          </CopyToClipboard>
                          </Box>
              )}

              {/* Submit Button */}
                              <Button 
                onClick={postInvestment} 
                disabled={isInvesting || !amount || !currentDuration || !source || !selectedPlan}
                variant="contained"
                size="large"
                sx={{
                  height: 48,
                  background: '#F7931A',
                  marginTop: 2,
                  '&:hover': {
                    background: '#E8851A'
                  }
                }}
              >
                {isInvesting ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={20} sx={{ color: 'white' }} />
                    Processing...
                  </Box>
                ) : (
                  'Begin Investment'
                )}
              </Button>
          </Box> 
          
        </DialogContent>
  }
      </Dialog>
      </Box>
    );
  } catch (error) {
    console.error('CategoryPlans component error:', error);
    setComponentError(error);
    return (
      <Box sx={{ 
        padding: 3, 
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto'
      }}>
        <Alert severity="error" sx={{ marginBottom: 2 }}>
          An error occurred while loading the investment portfolios. Please refresh the page.
        </Alert>
        <Button 
          onClick={() => window.location.reload()} 
          variant="contained"
          sx={{ background: '#F7931A' }}
        >
          Refresh Page
        </Button>
      </Box>
    );
  }
}

export default CategoryPlans
